import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04695977&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04695977`,
  },
];

class NCT04695977 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:6600,width:'100%',border:'none'}} title="NCT04695977" src="https://connect.trialscope.com/studies/a6a22fc6-ddcb-4ac1-b85d-9c97594e94f0?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04695977;
